export default "__VITE_ASSET__ZI67Fqt___"